// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Operator-console top tab bar: Alarms · Anomalies · Routine · Recommendations ·
// Closed, each with a severity-colored count badge. Thin wrapper over PageTabs
// that supplies the /home route table and the badge colors.

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PageTabs, { type PageTab } from '../PageTabs';
import { ALARM_TABS, type AlarmTabKey } from '../../../services/alarmSelectors';
import { useFlagOn } from '../../../hooks/useFlagOn';

export function AlarmTabs({
  active,
  counts,
}: {
  active: AlarmTabKey;
  counts: Record<AlarmTabKey, number | null>;
}) {
  const group = useSearchParams()[0].get('group');
  const search = group ? `?${new URLSearchParams({ group })}` : '';
  const routineTab = useFlagOn('routineTabEnabled');
  const tabs: PageTab[] = ALARM_TABS.filter(t => t.key !== 'routine' || routineTab).map(t => ({
    key: t.key,
    label: t.label,
    to: t.route + search,
    count: counts[t.key],
    countFg: t.fg,
    countBg: t.bg,
    countMax: undefined,
  }));

  return (
    <PageTabs tabs={tabs} activeKey={active} ariaLabel="Alarm views" testIdPrefix="alarm-tab" />
  );
}

export default AlarmTabs;
